import { type Till } from "~/api/tills/types";

/**
 * Checks if barcoded products should be hidden based on the till's configuration.
 * This handles the type guard logic for checking `barcodedProductsDisplayMode` across
 * different till types (POS, kiosk, self-service, etc.).
 */
export function shouldHideBarcodedProducts(
  till: Till | null | undefined
): boolean {
  if (!till?.config) return false;

  if (
    "barcodedProductsDisplayMode" in till.config &&
    till.config.barcodedProductsDisplayMode === "hidden"
  ) {
    return true;
  }

  return false;
}
